export const ar = {
  // Header
  title: "نظام إدارة الموظفين",
  subtitle: "إدارة شاملة لبيانات الموظفين وتتبع الحالة",

  // Buttons
  addEmployee: "إضافة موظف جديد",
  add: "إضافة",
  export: " تصدير إكسل",
  share: "مشاركة",
  archive: "عرض الأرشيف",
  cancel: "إلغاء",
  update: "تحديث الموظف",
  save: "حفظ",
  delete: "حذف",
  restore: "استعادة",
  restoreAll: "استعادة الكل",
  deleteAll: "حذف الكل",
  updating: "جاري التحديث...",
  adding: "جاري الإضافة...",
  // Table Headers
  employee: "الموظف",
  department: "القسم",
  salary: "الراتب",
  joinDate: "تاريخ التعيين",
  status: "الحالة",
  actions: "الإجراءات",
  archivedDate: "تاريخ الأرشفة",
  company: "الشركة",

  // Departments
  infotech: "تكنولوجيا المعلومات",
  humanResources: "الموارد البشرية",
  finance: "المالية",
  marketing: "التسويق",
  operations: "العمليات",
  sales: "المبيعات",
  customerService: "خدمة العملاء",

  // Filters
  filtersActions: "الفلاتر والإجراءات",
  showing: "عرض",
  of: "من",
  records: "سجل",
  searchEmployee: "بحث عن موظف",
  allDepartments: "جميع الأقسام",
  Status: "الحالة",
  allStatuses: "جميع الحالات",
  allCompanies: "جميع الشركات",
  searchDepartment: "اختر القسم",
  selectStatus: "اختر الحالة",

  // Stats
  totalEmployees: "إجمالي الموظفين",
  activeEmployees: "الموظفون النشطون",
  onLeave: "في إجازة",
  archived: "المؤرشف",
  newEmployees: "موظفون جدد",
  total: "الإجمالي",
  active: "نشط",
  currentlyWorking: "يعملون حالياً",
  currentlyOnLeave: "في إجازة حالياً",
  archivedEmployees: "الموظفون المؤرشفون",
  joinedRecently: "انضموا مؤخراً",
  allRegisteredEmployees: "جميع الموظفين المسجلين",
  allEmployees: "جميع الموظفين",

  // Status
  statusActive: "نشط",
  statusOnLeave: "في إجازة",
  statusInactive: "غير نشط",
  statusArchived: "مؤرشف",
  statusUnknown: "غير معروف",

  // Messages
  loading: "جاري التحميل...",
  loadingEmployees: "جاري تحميل الموظفين...",
  noEmployees: "لا يوجد موظفون",
  noArchivedEmployees: "لا يوجد موظفون مؤرشفون",
  employeesArchivedMessage: "الموظفون المؤرشفون سيظهرون هنا",
  showAll: "عرض الكل",
  showLess: "عرض أقل",
  more: "المزيد",

  // Modals
  employeeDetails: "تفاصيل الموظف",
  editEmployee: "تعديل الموظف",
  addNewEmployee: "إضافة موظف جديد",
  viewArchive: "الموظفون المؤرشفون",
  archivedDescription:
    "الموظفون المؤرشفون محفوظون هنا بأمان. يمكنك استعادتهم إلى الحالة النشطة أو حذفهم نهائياً.",

  // Form Labels
  fullName: "الاسم الكامل",
  emailAddress: "البريد الإلكتروني",
  phoneNumber: "رقم الهاتف",
  nationalId: "الرقم القومي",
  position: "المنصب",
  laborMode: "نظام العمل",
  companyName: "الشركة",
  clientCode: "كود العميل",
  statusLabel: "الحالة",
  salaryLabel: "الراتب",
  dateOfBirth: "تاريخ الميلاد",
  gender: "النوع",
  maritalStatus: "الحالة الاجتماعية",
  nationality: "الجنسية",
  city: "المدينة",
  country: "الدولة",
  address: "العنوان",
  emergencyPhone: "هاتف الطوارئ",

  // Form Placeholders
  enterFullName: "أدخل الاسم الكامل",
  enterEmail: "أدخل البريد الإلكتروني",
  enterPhone: "أدخل رقم الهاتف",
  enterNationalId: "أدخل الرقم القومي",
  enterPosition: "أدخل المنصب",
  enterCompany: "أدخل اسم الشركة",
  enterClientCode: "أدخل كود العميل",
  enterSalary: "أدخل قيمة الراتب",
  selectGender: "اختر النوع",
  selectMaritalStatus: "اختر الحالة",
  enterNationality: "أدخل الجنسية",
  enterCity: "أدخل المدينة",
  enterCountry: "أدخل الدولة",
  enterAddress: "أدخل العنوان الكامل",
  searchNameIdEmail: "الاسم، الرقم، البريد...",
  searchNameId: "الاسم، الرقم...",

  // Form Sections
  basicInformation: "المعلومات الأساسية",
  workInformation: "معلومات العمل",
  personalInformation: "المعلومات الشخصية",
  contactInformation: "معلومات الاتصال",
  educationInformation: "المعلومات التعليمية",
  insuranceInformation: "معلومات التأمين",
  systemInformation: "معلومات النظام",

  // Gender Options
  male: "ذكر",
  female: "أنثى",

  // Marital Status Options
  single: "أعزب",
  married: "متزوج",
  divorced: "مطلق",
  widowed: "أرمل",

  // Labor Mode Options
  fullTime: "دوام كامل",
  partTime: "دوام جزئي",
  contract: "عقد",
  temporary: "مؤقت",
  freelance: "عمل حر",

  // Info Labels
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  employeeId: "رقم الموظف",
  hiringDate: "تاريخ التعيين",
  netSalary: "صافي الراتب",
  workingExperience: "الخبرة العملية",
  contractDate: "تاريخ العقد",
  contractExpiration: "انتهاء العقد",
  termOfContract: "مدة العقد",
  insuranceStatus: "حالة التأمين",
  insuranceNumber: "رقم التأمين",
  insuranceSalary: "راتب التأمين",
  insuranceStartDate: "تاريخ بدء التأمين",
  monthsForInsurance: "أشهر التأمين",
  graduateInstitution: "المؤسسة التعليمية",
  major: "التخصص",
  graduationYear: "سنة التخرج",
  createdAt: "تاريخ الإنشاء",
  lastUpdated: "آخر تحديث",
  years: "سنوات",
  months: "أشهر",

  // Action Buttons
  viewDetails: "عرض التفاصيل",
  deleteEmployee: "حذف الموظف",
  archiveEmployee: "أرشفة الموظف",
  restoreEmployee: "استعادة الموظف",
  permanentlyDelete: "حذف نهائي",

  // Confirmation Messages
  confirmDelete: "هل أنت متأكد من حذف هذا الموظف؟",
  confirmArchive: "هل أنت متأكد من أرشفة هذا الموظف؟",
  confirmRestore: "هل أنت متأكد من استعادة هذا الموظف؟",
  confirmPermanentDelete:
    "هل أنت متأكد من الحذف النهائي لهذا الموظف؟ لا يمكن التراجع عن هذا الإجراء.",
  confirmRestoreAll: "هل أنت متأكد من استعادة كل",
  archivedEmployeesQuestion: "الموظفين المؤرشفين؟",
  confirmDeleteAll: "هل أنت متأكد من الحذف النهائي لكل",
  cannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",

  // Success Messages
  employeeUpdated: "تم تحديث الموظف بنجاح!",
  employeeAdded: "تم إضافة الموظف بنجاح!",
  employeeDeleted: "تم حذف الموظف بنجاح!",
  employeeArchived: "تم أرشفة الموظف بنجاح!",
  employeeRestored: "تم استعادة الموظف بنجاح!",
  allEmployeesDeleted: "تم حذف جميع الموظفين المؤرشفين نهائياً!",
  exportSuccess: "تم تصدير",
  filteredEmployees: "الموظفين المفلترين بنجاح!",
  exportSuccessCSV: "الموظفين المفلترين كملف CSV!",

  // Error Messages
  nameRequired: "الاسم مطلوب",
  emailRequired: "البريد الإلكتروني مطلوب",
  emailInvalid: "البريد الإلكتروني غير صحيح",
  departmentRequired: "القسم مطلوب",
  positionRequired: "المنصب مطلوب",
  failedToFetch: "فشل في جلب بيانات الموظف",
  failedToUpdate: "فشل في تحديث الموظف",
  failedToAdd: "فشل في إضافة الموظف",
  failedToDelete: "فشل في حذف الموظف",
  failedToArchive: "فشل في أرشفة الموظف",
  failedToRestore: "فشل في استعادة الموظف",
  failedToExport: "فشل في تصدير بيانات الموظفين",

  // Archive Stats
  totalArchived: "إجمالي المؤرشف",
  archivedThisMonth: "المؤرشف هذا الشهر",
  archivedEmployee: "موظف مؤرشف",

  // List Labels
  employeeList: "قائمة الموظفين",
  employeesCount: "موظف",
  employees: "الموظفين",

  viewDocuments: "عرض المستندات",
  documents: "المستندات",
  noDocuments: "لا توجد مستندات",
  download: "تحميل",
  documentChecklist: "قائمة فحص المستندات",
  photos: "الصور",
  birthForm: "شهادة الميلاد",
  graduation: "شهادة التخرج",
  idCopy: "نسخة البطاقة",
  criminalRecord: "صحيفة الحالة الجنائية",
  workCertificate: "شهادة العمل",
  form111: "نموذج 111",
  updatingDocuments: "جاري تحديث المستندات...",
  documentsUpdated: "تم تحديث المستندات بنجاح!",
  failedToUpdateDocuments: "فشل في تحديث المستندات",

  // Not Available
  na: "غير متاح",
};

export default ar;
